import React, { useState, createContext, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './Header';
import Form from './Form';
import Home from './Home';
import Browse from './Browse';
import JobOfferDetails from './JobOfferDetails';
import Login from './Login';
import Signup from './Signup';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Profile from './Profile';
import CompleteAutocomplete from './CompleteAutocomplete';
import ThankYou from './ThankYou'; // Import at the top with other components
import MobileMessage from './MobileMessage'; // Import MobileMessage


// import ForgotPassword from './ForgotPassword';

// Create a context for authentication
export const AuthContext = createContext();

function App() {
    // const [auth, setAuth] = useState({ isLoggedIn: false, user: null });
    const [auth, setAuth] = useState({
        isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
        user: localStorage.getItem('user')
    });

    useEffect(() => {
        const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        const user = localStorage.getItem('user');
        setAuth({ isLoggedIn, user });
    }, [])

    // State to track whether the current device is mobile
    const [isMobile, setIsMobile] = useState(
        window.matchMedia("(max-width: 768px)").matches
      );
  
      // Effect to listen for changes in screen size
      useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 768px)");
        const handleMediaChange = () => setIsMobile(mediaQuery.matches);
  
        mediaQuery.addListener(handleMediaChange);
  
        return () => mediaQuery.removeListener(handleMediaChange);
      }, []);
  

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            <BrowserRouter>
                <div className="App">
                    {isMobile ? (
                      <MobileMessage />
                    ) : (
                        <>
                            <Header />
                            <Routes>
                                {/* <Route path="/" element={<Home />} /> */}
                                <Route path="/" element={<Browse />} />
                                <Route path="/submit" element={<Form />} />
                                <Route path="/browse" element={<Browse />} />
                                <Route path="/jobOffer/:documentId" element={<JobOfferDetails />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/signup" element={<Signup />} />
                                <Route path="/forgot-password" element={<ForgotPassword />} />
                                <Route path="/reset-password/:token" element={<ResetPassword />} />
                                <Route path="/profile" element={<Profile />} />
                                <Route path="/search" element={<CompleteAutocomplete />} />
                                <Route path="/thank-you" element={<ThankYou />} />
                                {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
                                {/* Add more routes as needed */}
                            </Routes>
                        </>
                    )}
                </div>
            </BrowserRouter>
        </AuthContext.Provider>
    );
}

export default App;


